import {
  SET_CHART3_VALUES,
  SET_CHART4_VALUES,
  SET_CHART5_VALUES,
  SET_CHART6_VALUES,
} from './mutations.type'

export default {
  [SET_CHART3_VALUES](state, payload) {
    state.chart3.from_date = payload.from_date
    state.chart3.to_date = payload.to_date
  },
  [SET_CHART4_VALUES](state, payload) {
    state.chart4.from_date = payload.from_date
    state.chart4.to_date = payload.to_date
  },
  [SET_CHART5_VALUES](state, payload) {
    state.chart5.from_date = payload.from_date
    state.chart5.to_date = payload.to_date
  },
  [SET_CHART6_VALUES](state, payload) {
    state.chart6.from_date = payload.from_date
    state.chart6.to_date = payload.to_date
  },
}
